import { render, staticRenderFns } from "./OlxTemplate.vue?vue&type=template&id=5e2d8b83&scoped=true&"
import script from "./OlxTemplate.vue?vue&type=script&lang=js&"
export * from "./OlxTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d8b83",
  null
  
)

export default component.exports